import { getWindowLocation } from '@gov-nx/utils/web/utils/windowLocation';
import { PO_DEV_URL } from './constants';

const isLocalhost = () => getWindowLocation().hostname.includes('localhost');

/** SPA route NIA returns to; the dev bounce appends the Id/Result params. */
const AUTORIZACE_RESULT_PATH = 'autorizace/vysledek';

/**
 * Localhost cannot finish the NIA browser leg directly: NIA only accepts the
 * registered dev ReplyUrl, so it returns to the dev cluster and the local
 * session never sees the result. Instead we reuse the dev `/authz/start` cookie
 * bounce — it starts NIA with the registered ReplyUrl but records our localhost
 * `redirect-url`, so the dev nginx 302s the result back to localhost.
 *
 * Same contract as mobile's authz-start URL: raw scheme for `nia-url` and
 * `redirect-url`, only `id` is encoded. Enabled only on localhost, so deployed
 * environments are unaffected.
 */
const buildLocalhostAuthzStartUrl = (
	niaAuthorizaitionUrl: string,
	ukonId: string
) => {
	const redirectUrl = `${getWindowLocation().origin}/${AUTORIZACE_RESULT_PATH}`;
	return `${PO_DEV_URL}/authz/start?nia-url=${niaAuthorizaitionUrl}&id=${encodeURIComponent(
		ukonId
	)}&redirect-url=${redirectUrl}`;
};

export const getRedirectUrl = (
	niaAuthorizaitionUrl: string,
	ukonId: string
) => {
	// On localhost, bounce through the dev cookie mechanism so the result comes
	// back to the local session; deployed environments keep the direct NIA path.
	if (isLocalhost()) {
		return buildLocalhostAuthzStartUrl(niaAuthorizaitionUrl, ukonId);
	}

	const sp = new URLSearchParams({
		Id: ukonId,
		// ReplyUrl is registered in NIA and handled by nginx, not a SPA route
		ReplyUrl: `${getWindowLocation().origin}/autorizace`,
	});

	return `${niaAuthorizaitionUrl}?${sp.toString()}`;
};
